import defaultListingImageURL from '../assets/default-listing-image-chevalier.png';

export const DEFAULT_LISTING_IMAGE_URL = defaultListingImageURL;
export const DEFAULT_LISTING_IMAGE_ID = 'default-listing-image-chevalier';

const DEFAULT_LISTING_IMAGE_DIMENSIONS = {
  'listing-card': { width: 400, height: 400 },
  'listing-card-2x': { width: 800, height: 800 },
  'listing-card-4x': { width: 1600, height: 1600 },
  'listing-card-6x': { width: 2400, height: 2400 },
  scaled: { width: 1254, height: 1254 },
  'scaled-small': { width: 320, height: 320 },
  'scaled-medium': { width: 640, height: 640 },
  'scaled-large': { width: 1024, height: 1024 },
  'scaled-xlarge': { width: 1254, height: 1254 },
  facebook: { width: 1200, height: 630 },
  twitter: { width: 600, height: 314 },
};

const defaultListingImageVariantNames = Object.keys(DEFAULT_LISTING_IMAGE_DIMENSIONS);

const createDefaultListingImageVariant = name => {
  const { width, height } = DEFAULT_LISTING_IMAGE_DIMENSIONS[name];
  return {
    name,
    url: DEFAULT_LISTING_IMAGE_URL,
    width,
    height,
  };
};

export const DEFAULT_LISTING_IMAGE = {
  id: DEFAULT_LISTING_IMAGE_ID,
  type: 'image',
  attributes: {
    variants: defaultListingImageVariantNames.reduce((variants, variantName) => {
      return {
        ...variants,
        [variantName]: createDefaultListingImageVariant(variantName),
      };
    }, {}),
  },
};

export const isDefaultListingImage = image => image?.id === DEFAULT_LISTING_IMAGE_ID;

const getListingImages = listingOrImages => {
  if (Array.isArray(listingOrImages)) {
    return listingOrImages;
  }

  return listingOrImages?.images;
};

export const hasUploadedListingImages = listingOrImages => {
  const images = getListingImages(listingOrImages);
  return Array.isArray(images) && images.length > 0;
};

export const getListingImagesWithFallback = listingOrImages => {
  const images = getListingImages(listingOrImages);

  if (!Array.isArray(images)) {
    return [];
  }

  return images.length > 0 ? images : [DEFAULT_LISTING_IMAGE];
};

export const getFirstListingImage = listingOrImages => {
  return getListingImagesWithFallback(listingOrImages)[0] || null;
};

export const getListingImageVariantNames = (image, variantPrefix) => {
  const variants = image?.attributes?.variants || {};
  const variantNames = Object.keys(variants);

  return variantPrefix ? variantNames.filter(k => k.startsWith(variantPrefix)) : variantNames;
};
